import {
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Tag,
  TagLabel,
  chakra,
} from '@chakra-ui/react'
import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { colors } from '../../../../ui-kit'
import type { BooleanOperator } from '../../../interfaces'

interface Props {
  scope: string
  boolean: BooleanOperator
  onChangeBoolean(newBoolean: BooleanOperator): void
}

const SearchBoolean = (props: Props): React.ReactElement => {
  const { scope, boolean, onChangeBoolean } = props

  const { t } = useTranslation()

  const button = useMemo(
    () =>
      scope === 'outer' ? (
        <MenuButton paddingX="0.5em">
          <chakra.div marginTop="0.5em">{boolean}</chakra.div>
        </MenuButton>
      ) : (
        <MenuButton>
          <Tag
            borderRadius="none"
            marginTop="0.5em"
            padding="0.5em"
            height="2rem"
          >
            <TagLabel color={colors.appSlate}>{boolean}</TagLabel>
          </Tag>
        </MenuButton>
      ),
    [scope, boolean],
  )

  return (
    <Menu>
      {button}
      <MenuList>
        <MenuItem onClick={() => void onChangeBoolean('and')}>
          {t('and', 'and')}
        </MenuItem>
        <MenuItem onClick={() => void onChangeBoolean('or')}>
          {t('or', 'or')}
        </MenuItem>
      </MenuList>
    </Menu>
  )
}

export default SearchBoolean
